import { SuggestionsDB } from '../../indexed_db/suggestionsDB';

let suggestionsDb: SuggestionsDB;

const suggestionsDbFactory = () => (suggestionsDb = new SuggestionsDB());

export const getSuggestionsDbApi = (): SuggestionsDB => suggestionsDb ?? suggestionsDbFactory();
